import { getReportHeaders } from "@adapters/infrastructures/urlConfig/Reports/reportHeaders";
import urlConfig from "@adapters/infrastructures/urlConfig/Reports/reportsUrl";
import { ReportName, ReportType, } from "@domains/aggregates/interfaces/Reports/iHoldingReport";
import { EmailReportParams } from "@domains/dto/Reports/HoldingReport/Request";
import { ILoginAccountTypes } from "@domains/features/LoginFlow/entities/CommonLoginData";
import { getIsInIFrame } from "@domains/utils/tokenParser";
import { ELoginSource } from "@domains/entities/interfaces/iUserDetails";
export class DownloadReportsRepository {
    constructor(http, file, accountDetails) {
        this.http = http;
        this.file = file;
        this.accountDetails = accountDetails;
    }
    addSearchParams(url, searchparams) {
        if (!searchparams)
            return url;
        searchparams.map((param) => {
            url.searchParams.append(param.key, param.value);
        });
        return url;
    }
    async downloadRevampPdfExcel(downloadRequestData) {
        var _a, _b, _c, _d;
        const accountCode = await this.accountDetails.getAccountCode();
        if (!accountCode)
            return;
        let reporttype = (downloadRequestData === null || downloadRequestData === void 0 ? void 0 : downloadRequestData.reportType) ? ("/" + (downloadRequestData === null || downloadRequestData === void 0 ? void 0 : downloadRequestData.reportType)) : "";
        let url = new URL(urlConfig[(_a = downloadRequestData === null || downloadRequestData === void 0 ? void 0 : downloadRequestData.urlParts) === null || _a === void 0 ? void 0 : _a.firstPart] +
            ((_b = downloadRequestData === null || downloadRequestData === void 0 ? void 0 : downloadRequestData.urlParts) === null || _b === void 0 ? void 0 : _b.secondPart) + reporttype
            + ((_d = (_c = downloadRequestData === null || downloadRequestData === void 0 ? void 0 : downloadRequestData.urlParts) === null || _c === void 0 ? void 0 : _c.version) !== null && _d !== void 0 ? _d : ""));
        url = this.addSearchParams(url, downloadRequestData.searchParams);
        return await this.callDownloadFileApi(url, accountCode, downloadRequestData === null || downloadRequestData === void 0 ? void 0 : downloadRequestData.method, downloadRequestData === null || downloadRequestData === void 0 ? void 0 : downloadRequestData.requestBody);
    }
    async emailRevampReport(emailRequestData) {
        var _a, _b, _c, _d, _e;
        const accountCode = await this.accountDetails.getAccountCode();
        if (!accountCode)
            return;
        let url = new URL(urlConfig[(_a = emailRequestData === null || emailRequestData === void 0 ? void 0 : emailRequestData.urlParts) === null || _a === void 0 ? void 0 : _a.firstPart] +
            ((_b = emailRequestData === null || emailRequestData === void 0 ? void 0 : emailRequestData.urlParts) === null || _b === void 0 ? void 0 : _b.secondPart) +
            (((_c = emailRequestData === null || emailRequestData === void 0 ? void 0 : emailRequestData.urlParts) === null || _c === void 0 ? void 0 : _c.thirdPart)
                ? (_d = emailRequestData === null || emailRequestData === void 0 ? void 0 : emailRequestData.urlParts) === null || _d === void 0 ? void 0 : _d.thirdPart
                : "/email"));
        url = this.addSearchParams(url, (_e = emailRequestData === null || emailRequestData === void 0 ? void 0 : emailRequestData.searchParams) !== null && _e !== void 0 ? _e : []);
        return await this.http
            .makeApiCall({
            method: "POST",
            url: url.toString(),
            body: emailRequestData.requestBody,
            headers: getReportHeaders(accountCode),
            avoidAuthToken: getIsInIFrame(),
        })
            .then((result) => {
            return result.status;
        });
    }
    async donwloadPdf(downloadRequestData) {
        var _a, _b;
        const accountCode = await this.accountDetails.getAccountCode();
        const isImpersonated = await this.accountDetails.getCipFlag();
        const isAdminLogin = await this.accountDetails.getLoginSrc() === ELoginSource.NESTTRADER;
        const salesNativeApp = JSON.parse(localStorage.getItem("sales_native_app"));
        const shouldBePasswordProtected = isImpersonated || isAdminLogin || salesNativeApp; // sales web has isAdminLogin
        if (accountCode == undefined || accountCode == null || accountCode == "") {
            return false;
        }
        let url;
        if (downloadRequestData === null || downloadRequestData === void 0 ? void 0 : downloadRequestData.taxHarvesting) {
            url = new URL(urlConfig.taxReportUrl + "/" + (downloadRequestData === null || downloadRequestData === void 0 ? void 0 : downloadRequestData.taxHarvesting));
        }
        else if (downloadRequestData.usetaxDPURL && downloadRequestData.urlParts)
            url = new URL(urlConfig.dpURL + downloadRequestData.urlParts + "/pdf");
        else if (!downloadRequestData.usetaxDPURL && downloadRequestData.urlParts)
            url = new URL(urlConfig.downloadReportUrl +
                downloadRequestData.reportName +
                downloadRequestData.urlParts +
                "/pdf");
        else if (downloadRequestData.reportName == ReportName.MARGIN)
            url = new URL(urlConfig.margin + "/pdf");
        else if (downloadRequestData.reportName === ReportName.SUBSCRIPTION) {
            url = new URL(urlConfig.subscription + "/pdf");
            url.searchParams.append("subType", downloadRequestData.subReportName);
        }
        else if (downloadRequestData.reportName === ReportName.TRANSACTIONHISTORY)
            url = new URL(urlConfig.transaction + "/pdf");
        else if (downloadRequestData.AccType === ILoginAccountTypes.CO)
            url = new URL(urlConfig.downloadReportCOMUrl + downloadRequestData.reportName + "/pdf");
        else if (downloadRequestData.reportName === ReportName.DP)
            url = new URL(urlConfig.dpURL + "/pdf");
        else if (downloadRequestData === null || downloadRequestData === void 0 ? void 0 : downloadRequestData.isConsolidated) {
            let endPart = "";
            if ((_a = downloadRequestData.reportType) === null || _a === void 0 ? void 0 : _a.split("/"))
                endPart =
                    ((_b = downloadRequestData.reportType) === null || _b === void 0 ? void 0 : _b.split("/").length) > 1
                        ? downloadRequestData.reportType.split("/")[1]
                        : downloadRequestData.reportType.split("/")[0];
            url = new URL(urlConfig.familyTagging +
                "/" +
                downloadRequestData.reportName +
                "/pdf/" +
                endPart);
        }
        else if (downloadRequestData.reportType === ReportType.PDF_SUMMARY ||
            downloadRequestData.reportType === ReportType.PDF_DETAIL) {
            url = new URL(urlConfig.downloadReportUrl +
                downloadRequestData.reportName +
                "/pdf/" +
                downloadRequestData.reportType.split("/")[1]);
        }
        else
            url = new URL(urlConfig.downloadReportUrl + downloadRequestData.reportName + "/pdf");
        if (downloadRequestData === null || downloadRequestData === void 0 ? void 0 : downloadRequestData.version) {
            url = new URL(url.toString() + (downloadRequestData === null || downloadRequestData === void 0 ? void 0 : downloadRequestData.version));
        }
        if (downloadRequestData.reportName != ReportName.MARGIN &&
            downloadRequestData.reportName != ReportName.DP &&
            !downloadRequestData.usetaxDPURL) {
            if (downloadRequestData === null || downloadRequestData === void 0 ? void 0 : downloadRequestData.isConsolidated)
                url.searchParams.append("accountIds", downloadRequestData.accodes);
            else
                url.searchParams.append("accountId", (downloadRequestData === null || downloadRequestData === void 0 ? void 0 : downloadRequestData.accodes)
                    ? downloadRequestData === null || downloadRequestData === void 0 ? void 0 : downloadRequestData.accodes
                    : accountCode);
        }
        if (downloadRequestData.usetaxDPURL && (downloadRequestData === null || downloadRequestData === void 0 ? void 0 : downloadRequestData.fromDate) && (downloadRequestData === null || downloadRequestData === void 0 ? void 0 : downloadRequestData.toDate)) {
            url.searchParams.append("accountCode", (downloadRequestData === null || downloadRequestData === void 0 ? void 0 : downloadRequestData.accodes)
                ? downloadRequestData === null || downloadRequestData === void 0 ? void 0 : downloadRequestData.accodes
                : accountCode);
        }
        if (downloadRequestData.dpId)
            url.searchParams.append("dpId", downloadRequestData.dpId);
        if (downloadRequestData.reportName != ReportName.HOLDINGS &&
            downloadRequestData.reportName != ReportName.SUBSCRIPTION && (downloadRequestData === null || downloadRequestData === void 0 ? void 0 : downloadRequestData.fromDate)) {
            url.searchParams.append("fromDate", downloadRequestData === null || downloadRequestData === void 0 ? void 0 : downloadRequestData.fromDate);
        }
        if (downloadRequestData.reportName === ReportName.PNL && (downloadRequestData === null || downloadRequestData === void 0 ? void 0 : downloadRequestData.toDate)) {
            url.searchParams.append("toDate", downloadRequestData === null || downloadRequestData === void 0 ? void 0 : downloadRequestData.toDate);
            url.searchParams.append("assetType", typeof downloadRequestData.assetType === "object"
                ? downloadRequestData.assetType.join(",")
                : downloadRequestData.assetType);
            url.searchParams.append("duration", downloadRequestData.duration);
        }
        if ((downloadRequestData.reportName === ReportName.TAX ||
            downloadRequestData.reportName === ReportName.TRANSACTIONHISTORY ||
            downloadRequestData.reportName === ReportName.LEDGER) && (downloadRequestData === null || downloadRequestData === void 0 ? void 0 : downloadRequestData.toDate))
            url.searchParams.append("toDate", downloadRequestData === null || downloadRequestData === void 0 ? void 0 : downloadRequestData.toDate);
        if (downloadRequestData.reportName === ReportName.HOLDINGS)
            url.searchParams.append("date", downloadRequestData === null || downloadRequestData === void 0 ? void 0 : downloadRequestData.date);
        if (downloadRequestData.scripIdentifier)
            url.searchParams.append("scripIdentifier", downloadRequestData.scripIdentifier.toString());
        if (downloadRequestData.expiryMonth)
            url.searchParams.append("expiryMonth", downloadRequestData.expiryMonth.toString());
        if (downloadRequestData.underlyingAsset)
            url.searchParams.append("underlyingAsset", downloadRequestData.underlyingAsset.toString());
        if (downloadRequestData.reportName === ReportName.LEDGER) {
            if (downloadRequestData.AccType === ILoginAccountTypes.CO)
                url.searchParams.append("entity", downloadRequestData.entity.toString());
            else {
                url.searchParams.append("isMtf", downloadRequestData.isMTF.toString());
                url.searchParams.append("segment", downloadRequestData.segment.toString());
            }
        }
        if (downloadRequestData.currentValue)
            url.searchParams.append("currentValue", downloadRequestData.currentValue);
        if (downloadRequestData.ledgerType)
            url.searchParams.append("ledgerType", downloadRequestData.ledgerType);
        if (downloadRequestData.dpType)
            url.searchParams.append("dpType", downloadRequestData.dpType);
        if (shouldBePasswordProtected)
            url.searchParams.append(downloadRequestData.reportName === ReportName.LEDGER ? "pwdProtected" : "isPwdProtected", "true");
        return await this.callDownloadFileApi(url, accountCode, downloadRequestData.method, downloadRequestData === null || downloadRequestData === void 0 ? void 0 : downloadRequestData.requestBody);
    }
    async donwloadExel(downloadRequestData) {
        const accountCode = await this.accountDetails.getAccountCode();
        if (accountCode == undefined || accountCode == null || accountCode == "") {
            return false;
        }
        const isImpersonated = await this.accountDetails.getCipFlag();
        const isAdminLogin = await this.accountDetails.getLoginSrc() === ELoginSource.NESTTRADER;
        const salesNativeApp = JSON.parse(localStorage.getItem("sales_native_app"));
        const shouldBePasswordProtected = isImpersonated || isAdminLogin || salesNativeApp; // sales web has isAdminLogin
        let url;
        if (downloadRequestData.usetaxDPURL && downloadRequestData.urlParts)
            url = new URL(urlConfig.dpURL + downloadRequestData.urlParts + "/excel");
        else if (!downloadRequestData.usetaxDPURL && downloadRequestData.urlParts)
            url = new URL(urlConfig.downloadReportUrl +
                downloadRequestData.reportName +
                downloadRequestData.urlParts +
                "/excel");
        else if (downloadRequestData.reportName == ReportName.MARGIN)
            url = new URL(urlConfig.margin + "/excel");
        else if (downloadRequestData.reportName === ReportName.SUBSCRIPTION) {
            url = new URL(urlConfig.subscription + "/excel");
            url.searchParams.append("subType", downloadRequestData.subReportName);
        }
        else if (downloadRequestData.reportName === ReportName.TRANSACTIONHISTORY)
            url = new URL(urlConfig.transaction + "/excel");
        else if (downloadRequestData.AccType === ILoginAccountTypes.CO)
            url = new URL(urlConfig.downloadReportCOMUrl +
                downloadRequestData.reportName +
                "/excel");
        else if (downloadRequestData === null || downloadRequestData === void 0 ? void 0 : downloadRequestData.isConsolidated) {
            url = new URL(urlConfig.familyTagging +
                "/" +
                downloadRequestData.reportName +
                "/excel");
        }
        else
            url = new URL(urlConfig.downloadReportUrl + downloadRequestData.reportName + "/excel");
        if (downloadRequestData === null || downloadRequestData === void 0 ? void 0 : downloadRequestData.version) {
            url = new URL(url.toString() + (downloadRequestData === null || downloadRequestData === void 0 ? void 0 : downloadRequestData.version));
        }
        if (!downloadRequestData.usetaxDPURL) {
            if (downloadRequestData === null || downloadRequestData === void 0 ? void 0 : downloadRequestData.isConsolidated)
                url.searchParams.append("accountIds", downloadRequestData.accodes);
            else
                url.searchParams.append("accountId", (downloadRequestData === null || downloadRequestData === void 0 ? void 0 : downloadRequestData.accodes)
                    ? downloadRequestData === null || downloadRequestData === void 0 ? void 0 : downloadRequestData.accodes
                    : accountCode);
        }
        if (downloadRequestData.usetaxDPURL)
            url.searchParams.append("accountCode", (downloadRequestData === null || downloadRequestData === void 0 ? void 0 : downloadRequestData.accodes)
                ? downloadRequestData === null || downloadRequestData === void 0 ? void 0 : downloadRequestData.accodes
                : accountCode);
        if (downloadRequestData.dpId)
            url.searchParams.append("dpId", downloadRequestData.dpId);
        if ((downloadRequestData.reportName === ReportName.PNL ||
            downloadRequestData.reportName === ReportName.PNL_TRANSACTION_REPORT ||
            downloadRequestData.reportName === ReportName.TAX ||
            downloadRequestData.reportName === ReportName.TRANSACTIONHISTORY ||
            downloadRequestData.reportName === ReportName.LEDGER) && (downloadRequestData === null || downloadRequestData === void 0 ? void 0 : downloadRequestData.fromDate)) {
            url.searchParams.append("fromDate", downloadRequestData.fromDate);
        }
        if (downloadRequestData.reportName === ReportName.HOLDINGS) {
            url.searchParams.append("date", downloadRequestData.date);
        }
        if ((downloadRequestData.reportName === ReportName.TAX ||
            downloadRequestData.reportName === ReportName.TRANSACTIONHISTORY ||
            downloadRequestData.reportName === ReportName.LEDGER) && (downloadRequestData === null || downloadRequestData === void 0 ? void 0 : downloadRequestData.toDate))
            url.searchParams.append("toDate", downloadRequestData === null || downloadRequestData === void 0 ? void 0 : downloadRequestData.toDate);
        if ((downloadRequestData.reportName === ReportName.PNL ||
            downloadRequestData.reportName === ReportName.PNL_TRANSACTION_REPORT) && (downloadRequestData === null || downloadRequestData === void 0 ? void 0 : downloadRequestData.toDate)) {
            url.searchParams.append("toDate", downloadRequestData === null || downloadRequestData === void 0 ? void 0 : downloadRequestData.toDate);
            url.searchParams.append("assetType", typeof downloadRequestData.assetType === "object"
                ? downloadRequestData.assetType.join(",")
                : downloadRequestData.assetType);
            url.searchParams.append("duration", downloadRequestData.duration);
        }
        if (downloadRequestData.currentValue)
            url.searchParams.append("currentValue", downloadRequestData.currentValue);
        if (downloadRequestData.scripIdentifier) {
            url.searchParams.append("scripIdentifier", downloadRequestData.scripIdentifier.toString());
        }
        if (downloadRequestData.expiryMonth)
            url.searchParams.append("expiryMonth", downloadRequestData.expiryMonth.toString());
        if (downloadRequestData.underlyingAsset)
            url.searchParams.append("underlyingAsset", downloadRequestData.underlyingAsset.toString());
        if (downloadRequestData.reportName === ReportName.LEDGER) {
            if (downloadRequestData.AccType === ILoginAccountTypes.CO)
                url.searchParams.append("entity", downloadRequestData.entity.toString());
            else {
                url.searchParams.append("isMtf", downloadRequestData.isMTF.toString());
                url.searchParams.append("segment", downloadRequestData.segment.toString());
            }
        }
        if (downloadRequestData.ledgerType)
            url.searchParams.append("ledgerType", downloadRequestData.ledgerType);
        if (downloadRequestData.dpType)
            url.searchParams.append("dpType", downloadRequestData.dpType);
        if (shouldBePasswordProtected)
            url.searchParams.append(downloadRequestData.reportName === ReportName.LEDGER ? "pwdProtected" : "isPwdProtected", "true");
        return await this.callDownloadFileApi(url, accountCode);
    }
    async callDownloadFileApi(url, accountCode, method, requestPayload) {
        return await this.http
            .makeApiCall({
            method: method ? method : "GET",
            url: url.toString(),
            headers: getReportHeaders(accountCode),
            body: requestPayload,
            avoidAuthToken: getIsInIFrame(),
        })
            .then((file) => {
            this.file.saveFile(file);
            return true;
        });
    }
    async emailReport(emailData) {
        const accountCode = await this.accountDetails.getAccountCode();
        if (accountCode == undefined || accountCode == null || accountCode == "") {
            return false;
        }
        let isPdf = emailData.reportType == ReportType.PDF ||
            emailData.reportType == ReportType.PDF_DETAIL ||
            emailData.reportType == ReportType.PDF_SUMMARY;
        let isExcel = emailData.reportType == ReportType.EXCEL;
        let assetType = typeof emailData.assetType === "object"
            ? emailData.assetType.join(",")
            : emailData.assetType;
        let payload = new EmailReportParams((emailData === null || emailData === void 0 ? void 0 : emailData.accodes) ? emailData === null || emailData === void 0 ? void 0 : emailData.accodes : accountCode, emailData.fromDate, emailData.toDate, isPdf, isExcel, emailData.emailIds, assetType, emailData.financialYear, emailData.emailID, emailData.filePath, emailData.subReportName, emailData.scripIdentifier, emailData.dpId, emailData.expiryMonth, emailData.underlyingAsset, emailData.isMTF, emailData.segment, emailData.dpType, emailData.entity, emailData.ledgerType, emailData.currentValue, emailData.reportType === ReportType.PDF_DETAIL, emailData.reportType === ReportType.PDF_SUMMARY, emailData.duration);
        let url;
        if (emailData === null || emailData === void 0 ? void 0 : emailData.taxHarvesting) {
            url = new URL(urlConfig.taxReportUrl + "/" + (emailData === null || emailData === void 0 ? void 0 : emailData.taxHarvesting));
        }
        else if (emailData.usetaxDPURL && emailData.urlParts)
            url = new URL(urlConfig.dpURL + emailData.urlParts);
        else if (!emailData.usetaxDPURL && emailData.urlParts)
            url = new URL(urlConfig.downloadReportUrl + emailData.reportName + emailData.urlParts);
        else if (emailData.reportName === ReportName.MARGIN)
            url = urlConfig.margin;
        else if (emailData.reportName == ReportName.SUBSCRIPTION)
            url = urlConfig.subscription;
        else if (emailData.reportName == ReportName.TRANSACTIONHISTORY)
            url = urlConfig.transaction;
        else if (emailData.AccType === ILoginAccountTypes.CO)
            url = urlConfig.downloadReportCOMUrl + emailData.reportName;
        else if (emailData === null || emailData === void 0 ? void 0 : emailData.isConsolidated)
            url = urlConfig.familyTagging + "/" + emailData.reportName;
        else
            url = new URL(urlConfig.downloadReportUrl + emailData.reportName);
        url += "/email";
        if (emailData === null || emailData === void 0 ? void 0 : emailData.version) {
            url = new URL(url.toString() + emailData.version);
        }
        return await this.http
            .makeApiCall({
            method: "POST",
            url: url.toString(),
            body: payload,
            headers: getReportHeaders(accountCode),
            avoidAuthToken: getIsInIFrame(),
        })
            .then((result) => {
            return result.status;
        });
    }
}
